import StatusAlertSolid from '../assets/images/status-alert-solid.svg';
import UploadErrorIcon from '../assets/images/status-error-circle-solid.svg';

const MEDIA_OPTIONS = {
  headerText: 'Shared Images',
  infoText: 'Images shared in the chat will appear below within two minutes. Select one or more images to document in the chart, then select',
  additionalInfoText: 'Upload to KPHC.',
  pdfUnsupportedText: 'PDFs are not supported.',
  refresh: 'Refresh',
  noImagesText: 'There are no images to display at this time.'
};
const MEDIA_REFRESH_BUTTON = 'Refresh';

const UPLOAD_STATUS_CLASS_MAP = {
  SUCCESS: 'vve-image-upload-success',
  FAILED: 'vve-image-upload-failed',
  NOT_SELECTED: 'vve-image-not-selected'
};

const NOTIFICATION_BANNER_DETAILS = {
  partialError: {
    headline: 'Partial Upload',
    message: 'Please try failed images again.',
    alertIcon: StatusAlertSolid
  },
  serviceError: {
    headline: 'Service Unavailable',
    message: 'Please try again later.',
    alertIcon: UploadErrorIcon
  }
};

const UPLOAD_STATUS_TEXT_MAP = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  NOT_SELECTED: 'NOT_SELECTED'
};

const DESCRIPTION_VALIDATION_ERROR_MESSAGE = 'Special character not supported.';
const DESCRIPTION_CHARACTER_INPUT_LIMIT = 150;

const DESCRIPTION_BULLET_CHARACTERS = [
  '•',
  '‣',
  '◦',
  '○',
  '◉',
  '◎',
  '▪',
  '▫',
  '◈',
  '◆',
  '►',
  '▻',
  '◾',
  '❖',
  '⬤',
  '❉',
  '⚫',
  '⚪',
  '♦',
  '☞',
  '➔',
  '➤',
  '➣',
  '➽',
  '➺',
  '➪',
  '➡',
  '➭',
  'o',
  '–',
  '—',
  '-',
  '*',
  '+',
  '·',
  '‧',
  '⦁',
  '●',
  '▸',
  '☐',
  '☑',
  '☒',
  '□',
  '✓',
  '■',
  '☛',
  '›',
  '◇',
  '※',
  '▲',
  '▶',
  '★',
  '☆',
  '☼',
  '♦',
  '✗',
  '✘',
  '☓',
  '👉',
  '➡️',
  '✅',
  '☑️',
  '✔️',
  '🔴',
  '🟢',
  '🔵',
  '🟡',
  '🟣',
  '🟠',
  '🟤',
  '🔺',
  '🔻',
  '🔸',
  '🔹',
  '🔲',
  '🟩',
  '🟦',
  '🟥',
  '🟧',
  '🟨',
  '🟫'
];

const DESCRIPTION_BULLET_PATTERN = DESCRIPTION_BULLET_CHARACTERS.map(c => '\\u' + c.charCodeAt(0).toString(16).padStart(4, '0')).join('');

const MARKDOWN_BULLET_PATTERN = '[\\-*+]+';

const DESCRIPTION_ORDERED_PATTERN = [
  '\\d{1,3}[\\.\\)\\-:]', // numbers: 1. 2) 3- 4:
  '[a-zA-Z][\\.\\)\\-:]', // letters: a. B) c- D:
  '\\([a-zA-Z0-9]+\\)', // (a) (1) (I)
  '\\[[a-zA-Z0-9]+\\]', // [a] [1] [I]
  '[IVXLCDMivxlcdm]+[\\.\\)\\-:]' // roman numerals i. II) iii- IV:
].join('|');

const DESCRIPTION_SANITIZATION_REGEX = new RegExp(
  '^\\s*(([' + DESCRIPTION_BULLET_PATTERN + ']|' + MARKDOWN_BULLET_PATTERN + ')\\s*' + '|' + DESCRIPTION_ORDERED_PATTERN + '\\s*)+'
);

// Regex to forcibly remove ALL non-ASCII characters (for fallback after all other cleaning)
const REMOVE_NON_ASCII_REGEX = /[^\x00-\x7F]/g;
const COLLAPSE_SPACES_REGEX = /\s+/g;

export {
  MEDIA_OPTIONS,
  MEDIA_REFRESH_BUTTON,
  UPLOAD_STATUS_CLASS_MAP,
  NOTIFICATION_BANNER_DETAILS,
  UPLOAD_STATUS_TEXT_MAP,
  DESCRIPTION_VALIDATION_ERROR_MESSAGE,
  DESCRIPTION_CHARACTER_INPUT_LIMIT,
  DESCRIPTION_SANITIZATION_REGEX,
  REMOVE_NON_ASCII_REGEX,
  COLLAPSE_SPACES_REGEX
};
